@use '@swisspost/design-system-styles/core' as post;
@use '@swisspost/design-system-styles/variables/color';
@use '@swisspost/design-system-styles/components/forms';
@use '@swisspost/design-system-styles/components/floating-label';
@use '@swisspost/design-system-styles/components/grid';
@use '../../utils/utils.scss';
@use '../../utils/mixins.scss';

:host {
  display: block;
}

.search,
:host {
  height: 100%;
}

.search-button {
  @extend %nav-link;

  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-right: calc(1rem - 1px);
  padding-left: calc(1rem - 1px);

  @include mixins.min(lg) {
    padding: 0 calc(1.125rem - 1px);
  }

  @include mixins.min(xl) {
    padding: 0 calc(1.5rem - 1px);
  }

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }

  .visually-hidden {
    @include mixins.between(rg, lg) {
      @include mixins.reset-visually-hidden();

      font-weight: 300;
      margin-right: 0.5rem;
      cursor: pointer;
    }
  }
}

.flyout {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: white;
  overflow: auto;
  overscroll-behavior: contain;
  padding-top: 3.25rem;
  padding-bottom: 3.25rem;
  z-index: -1;
  transform: translateY(-100%);
  transition: transform 0.35s, box-shadow 0.35s;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  @include mixins.min(lg) {
    max-height: calc(100vh - var(--header-height) - var(--meta-header-height) - 1px);
    box-shadow: 0 0 1px 0 rgb(0 0 0 / 40%);

    &.open {
      box-shadow: 0 0 8px 0 rgb(0 0 0 / 40%);
    }
  }

  @include mixins.max(lg) {
    height: calc(100vh - var(--header-height) - 1px);
  }

  &.open {
    transform: translateY(0);
  }
}

.form-floating {
  .form-control,
  .form-control + label {
    padding-right: post.$input-padding-x * 3;
  }
}

.start-search-button {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  padding-right: 1rem;
  padding-left: 1rem;
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
}

.suggestions {
  margin: 1.5rem 0;

  a {
    padding: 0.75rem 1rem;

    &:hover,
    &:focus,
    &.selected {
      background: color.$gray-background;
    }

    &.parcel-suggestion {
      flex-wrap: wrap;
    }
  }
}

.search-recommendation__icon {
  height: 1.5em;
  width: 1.5em;
}
